import Super from '../../core/button.gjs';
import styles from './tertiary.module.scss';

export default class SpdsActionButtonTertiary extends Super {
  baseClass = 'spds-button spds-action-button';
  hasBorder = true;
  variantClass = 'spds-action-button-tertiary';
  variantStyles = styles;
}
